import React from 'react';
import { SnackbarProvider } from 'notistack';

import componentUtil from 'utils/component';
import ErrorBoundry from 'components/error-handler/error-boundry';
import HandleGlobalError from './handle-global-errors';

export default function withErrorHandlerHOC(Component) {
  const WithErrorHandler = (props) => {
    return (
      <ErrorBoundry>
        <SnackbarProvider maxSnack={3}>
          <HandleGlobalError />
          <Component {...props} />
        </SnackbarProvider>
      </ErrorBoundry>
    );
  };
  WithErrorHandler.displayName = componentUtil.getDisplayName(
    Component,
    'WithErrorHandler'
  );
  return WithErrorHandler;
}
